/** REST + WebSocket contract for support chat (not GraphQL). */
export class SupportChatApiError extends Error {
    status;
    body;
    constructor(message, status, body) {
        super(message);
        this.status = status;
        this.body = body;
        this.name = 'SupportChatApiError';
    }
}
